export const SET_CARD_DATA = '[CARDS] SET_CARD_DATA';

export const setCardData = (data) => ({
  type: SET_CARD_DATA,
  payload: data,
});
